import { Box, styled } from "@mui/material";
import { DarkModeBackground, ShGreenLightGradient } from "shared/SharedStyles/styleConstants";

export const CandidateWrapperBox = styled(Box)(
    ({ theme }) => ({
        flex: 1,
        background: theme.palette.mode === 'light' ? ShGreenLightGradient : DarkModeBackground
    })
);